var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { CacheClient, CacheLocation } from "../basics/client-caching.service";
import { autoinject } from "aurelia-dependency-injection";
import { Router } from "aurelia-router";
import * as Enumerable from "linq";
import { EventAggregator } from "aurelia-event-aggregator";
var NavigationClientService = /** @class */ (function () {
    function NavigationClientService(cacheClient, router, eventAggregator) {
        var _this = this;
        this.cacheClient = cacheClient;
        this.router = router;
        this.previousRouteKey = "previous-lottery-platform-route";
        this.navigationTitle = "";
        eventAggregator.subscribe("router:navigation:complete", function (response) {
            if (_this.router && _this.router.currentInstruction) {
                _this.cache(_this.router.currentInstruction.config.name, _this.router.currentInstruction.params);
            }
        });
    }
    NavigationClientService.prototype.navigateAndCache = function (route, params, inMemoryParams) {
        if (params === void 0) { params = undefined; }
        if (inMemoryParams === void 0) { inMemoryParams = null; }
        this.currentRouteInMemoryParams = inMemoryParams;
        var selectedRoute = Enumerable.from(this.router.routes).firstOrDefault(function (x) { return x.name == route; });
        if (selectedRoute)
            this.navigationTitle = selectedRoute.title;
        this.router.navigateToRoute(route, params);
    };
    NavigationClientService.prototype.setTitle = function (title) {
        this.navigationTitle = title;
    };
    NavigationClientService.prototype.cache = function (route, params) {
        this.currentRoute = route;
        this.currentRouteParams = params;
        this.cacheClient.put(this.previousRouteKey, {
            routeName: route,
            params: params
        }, CacheLocation.LocalStorage);
    };
    NavigationClientService.prototype.navigateToPreviousRoute = function () {
        var _this = this;
        this.cacheClient.get(this.previousRouteKey, CacheLocation.LocalStorage).then(function (route) {
            if (route && _this.currentRoute != route.routeName) {
                _this.router.navigateToRoute(route.routeName, route.params, { replace: true });
            }
        });
    };
    NavigationClientService = __decorate([
        autoinject,
        __metadata("design:paramtypes", [CacheClient, Router, EventAggregator])
    ], NavigationClientService);
    return NavigationClientService;
}());
export { NavigationClientService };
